<template>
	<div :class="{ 'hidden': hidden }" class="pagination-container">
		<el-pagination :background="background" :current-page="currentPage" :page-size="pageSize" :layout="layout"
			:page-sizes="pageSizes" :pager-count="validPagerCount" :total="total" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" />
	</div>
</template>

<script setup>
	// import { scrollTo } from '@/utils/scroll-to'
	const route = useRoute()
	const props = defineProps({
		total: {
			required: true,
			type: Number
		},
		page: {
			type: Number,
			default: 1
		},
		pageSize: {
			type: Number,
			default: 20
		},
		pageSizes: {
			type: Array,
			default () {
				return [20, 50, 100]
			}
		},
		// 移动端页码按钮的数量端默认值5
		pagerCount: {
			type: Number,
			default: 5 // 5-21之间 document.body.clientWidth < 992 ? 5 : 7
		},
		layout: {
			type: String,
			default: 'prev, pager, next, sizes, jumper'
			// default: 'total, sizes, prev, pager, next, jumper'
		},
		background: {
			type: Boolean,
			default: false
		},
		autoScroll: {
			type: Boolean,
			default: true
		},
		hidden: {
			type: Boolean,
			default: false
		}
	})

	const emit = defineEmits()
	const currentPage = computed({
		get() {
			return props.page
		},
		set(val) {
			emit('update:page', val)
		}
	})
	const currentPageSize = computed({
		get() {
			return props.pageSize
		},
		set(val) {
			emit('update:pageSize', val)
		}
	})

	// 限制 pagerCount 范围 20260928新增补充
	const validPagerCount = computed(() => {
		let count = props.pagerCount || 5
		if (route.path === '/projectCenter') {
			// <1240 → 2 需求列表
			if (windowWidth.value < 1240) {
				count = 3
			}
		}

		console.log(count, 'routeroute validPagerCount')
		return count
	})

	// 计算最大页码
	const maxPage = computed(() => Math.ceil(props.total / props.pageSize) || 1)

	// 20260928新增
	let rafId = null
	const windowWidth = ref(window.innerWidth)
	const handleResize = () => {
		// 用 requestAnimationFrame 节流，避免 resize 高频触发
		if (rafId) return
		rafId = requestAnimationFrame(() => {
			windowWidth.value = window.innerWidth
			rafId = null
		})
	}

	onMounted(() => {
		// 20260928 新增项目追踪 页码个数展示根据浏览器自适应
		if (route.path === '/projectCenter') {
			window.addEventListener('resize', handleResize)
			// 初始化时同步一次（防止首帧取到旧值）
			windowWidth.value = window.innerWidth
			console.log(windowWidth.value, 'routeroute')
		}
	})

	onBeforeUnmount(() => {
		// 20260928 新增项目追踪 页码个数展示根据浏览器自适应
		if (route.path === '/projectCenter') {
			window.removeEventListener('resize', handleResize)
			if (rafId) cancelAnimationFrame(rafId)
		}
	})

	// 监听 total 或 pageSize 变化，自动修正页码越界  20260909新增 当成员档案/综合档案/更新文档/产品说明/项目追踪 -- 超过最大页时 重置右侧部分及选中项
	watch(
		[() => props.total, () => props.pageSize, () => props.page],
		() => {
			const max = maxPage.value
			let newPage = props.page
			if (max > 0 && newPage > max) {
				newPage = max
			} else if (newPage < 1 && max > 0) {
				newPage = 1
			}
			if (newPage !== props.page) {
				emit('update:page', newPage)
				// 可选：触发 pagination 事件告知父组件
				emit('pagination', {
					page: newPage,
					pageSize: props.pageSize
				})
			}
		}
	)

	// 滚动到顶部（可自定义动画）
	const scrollToTop = () => {
		if (props.autoScroll) {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		}
	}

	function handleSizeChange(val) {
		// 改变每页条数后，当前页码可能需要重置为1（避免当前页无数据）
		let newPage = currentPage.value
		if (newPage * val > props.total) {
			newPage = 1
		}
		if (newPage !== currentPage.value) {
			currentPage.value = newPage
		}
		currentPageSize.value = val

		emit('pagination', {
			page: newPage,
			pageSize: val
		})
		scrollToTop()

		// if (currentPage.value * val > props.total) {
		// 	currentPage.value = 1
		// }
		// emit('pagination', {
		// 	page: currentPage.value,
		// 	pageSize: val
		// })

		// if (props.autoScroll) {
		//   scrollTo(0, 800)
		// }
	}

	function handleCurrentChange(val) {
		currentPage.value = val

		emit('pagination', {
			page: val,
			pageSize: currentPageSize.value
		})

		scrollToTop()
		// if (props.autoScroll) {
		//   scrollTo(0, 800)
		// }
	}
</script>

<style scoped>
	.pagination-container.hidden {
		display: none;
	}
</style>